import { render, staticRenderFns } from "./salesMethodDialog.vue?vue&type=template&id=124e484b&scoped=true"
import script from "./salesMethodDialog.vue?vue&type=script&lang=js"
export * from "./salesMethodDialog.vue?vue&type=script&lang=js"
import style0 from "./salesMethodDialog.vue?vue&type=style&index=0&id=124e484b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e484b",
  null
  
)

export default component.exports